import { RouteObject } from 'react-router';

import { CrmRoutePathKey } from '@anyx/common-routing';

import { routes as ChatRoutes } from '../chat/routing';

import { routes as AdminSectionRoutes } from './admin-section/routing';
import { routes as BroadcastRoutes } from './broadcast/routing';

const PATH_KEY = CrmRoutePathKey.enum.whatsapp;

export const routes: RouteObject[] = [
  {
    path: 'whatsapp',
    children: [...ChatRoutes(PATH_KEY), ...BroadcastRoutes, ...AdminSectionRoutes],
  },
];
